//  Name: sidebar
import Expanding from 'vue-bulma-expanding'
import { mapGetters } from 'vuex'
import { navigation } from '@/router/menu'
import { API, BLOG_URL } from '@/config'

import LinkedinAuth from '@/helpers/linkedin'
import FacebookAuth from '@/helpers/facebook'
import GoogleAuth from '@/helpers/google'

import '@/components/avatar'

export default {
  props: {
    show: Boolean
  },
  data () {
    return {
      blog: BLOG_URL,
      isReady: false,
      socialLib: null,
      menu: navigation,
      expandMenu: []
    }
  },
  watch: {
    $router (route) {
      this.isReady = true
      this.prepareMenu(route)
    }
  },
  computed: mapGetters({
    user: 'user',
    device: 'device'
  }),
  methods: {
    logout () {
      var vm = this
      if (vm.user.auth === 'facebook' || this.user.auth === 'linkedin' || this.user.auth === 'google') {
        vm.socialLib.singOut()
      }
      vm.$store.dispatch('logout').then(function () {
        console.log('Saliendo')
        vm.$router.push({name: 'login'})
      })
    },
    isExpanded (item) {
      return this.expandMenu[item.name]
    },
    toggle (item) {
      this.$set(this.expandMenu, item.name, !this.expandMenu[item.name])
    },
    generatePath (item) {
      return {name: item.name}
    },
    prepareMenu (here) {
      var expandMenu = {}
      for (var index in this.menu) {
        var item = this.menu[index]
        if (item.children) {
          var open = false
          for (var _index in item.children) {
            if (here.name === item.children[_index].name) {
              open = true
              break
            }
          }
          expandMenu[item.name] = open
        }
      }
      this.$set(this, 'expandMenu', expandMenu)
    }
  },
  mounted () {
    let route = this.$route
    if (route.name) {
      this.isReady = true
      this.prepareMenu(route)
    }
  },
  beforeMount () {
    if (this.user.auth === 'facebook') {
      this.$set(this, 'socialLib', FacebookAuth())
      this.socialLib.init(API.facebook)
    } else if (this.user.auth === 'linkedin') {
      this.$set(this, 'socialLib', LinkedinAuth())
      this.socialLib.init(API.linkedin)
    } else if (this.user.auth === 'google') {
      this.$set(this, 'socialLib', GoogleAuth())
      this.socialLib.init(API.google)
    }
  },
  components: {
    Expanding
  }
}



// WEBPACK FOOTER //
// ./src/components/sidebar/script.js